import { lazy } from 'react';

// project imports
import Loadable from 'components/Loadable';
import DashboardLayout from 'layout/Dashboard';
import { Navigate } from 'react-router-dom';

// render- Dashboard
const DashboardDefault = Loadable(lazy(() => import('pages/dashboard/default')));
const DashboardHome = Loadable(lazy(() => import('pages/dashboard/home')));
// render - color
const Color = Loadable(lazy(() => import('pages/component-overview/color')));
const Typography = Loadable(lazy(() => import('pages/component-overview/typography')));
const Shadow = Loadable(lazy(() => import('pages/component-overview/shadows')));

// render - sample page
const SamplePage = Loadable(lazy(() => import('pages/extra-pages/sample-page')));

// render - orders
const Orders = Loadable(lazy(() => import('pages/orders')));
const OrdersCreate = Loadable(lazy(() => import('pages/OrdersCreate')));
const OrdersEdit = Loadable(lazy(() => import('pages/OrdersEdit')));
const OrdersShow = Loadable(lazy(() => import('pages/OrdersShow')));
const OrdersReceive = Loadable(lazy(() => import('pages/OrdersReceive')));
const OrdersPrint = Loadable(lazy(() => import('pages/OrdersPrint')));
const OrdersPrintA4 = Loadable(lazy(() => import('pages/OrdersPrintA4')));
const Users = Loadable(lazy(() => import('pages/users')));
const Revenue = Loadable(lazy(() => import('pages/revenue')));
const Debts = Loadable(lazy(() => import('pages/debts')));
const Clients = Loadable(lazy(() => import('pages/clients')));
const Clothes = Loadable(lazy(() => import('pages/clothes')));
const FolkDances = Loadable(lazy(() => import('pages/folkDances')));
const Warehouse = Loadable(lazy(() => import('pages/warehouse')));
const Register = Loadable(lazy(() => import('pages/register')));
const Roles = Loadable(lazy(() => import('pages/roles')));
const Access = Loadable(lazy(() => import('pages/access')));
const Calendar = Loadable(lazy(() => import('pages/calendar')));
const ClientDetails = Loadable(lazy(() => import('pages/ClientDetails')));
const FolkDanceShow = Loadable(lazy(() => import('pages/folk-dance/FolkDanceShow')));
const FolkDanceEdit = Loadable(lazy(() => import('pages/folk-dance/FolkDanceEdit')));
const ClothesEdit = Loadable(lazy(() => import('pages/ClothesEdit')));
const ChangePassword = Loadable(lazy(() => import('pages/settings/ChangePassword')));
const Reservations = Loadable(lazy(() => import('pages/ReservationsPage')));
const OrdersCreateFromReservation = Loadable(lazy(() => import('pages/OrdersCreateFromReservation')));
const ReservationEdit = Loadable(lazy(() => import('pages/ReservationEdit')));
const OrderEditRequestsPage = Loadable(lazy(() => import('pages/OrderEditRequestsPage')));
const OrderEditRequestsList = Loadable(lazy(() => import('pages/OrderEditRequestsList')));

import ReservationShow from '@/pages/ReservationShow';
import ReservationNew from 'pages/ReservationNew';
import { constrainPoint } from '@fullcalendar/core/internal';


// ==============================|| MAIN ROUTING ||============================== //

const MainRoutes = {
  path: '/',
  element: <DashboardLayout />,
  children: [
    {
      path: '/',
      element: (
        localStorage.getItem('token')
          ? <Navigate to="/dashboard/default" replace />
          : <Navigate to="/login" replace />
      )
    },
    {
      path: 'dashboard',
      children: [
        {
          path: 'default',
          element: <DashboardDefault />
        }, {
          path: 'home',
          element: <DashboardHome />
        }
      ]
    },
    {
      path: 'typography',
      element: <Typography />
    },
    {
      path: 'color',
      element: <Color />
    },
    {
      path: 'shadow',
      element: <Shadow />
    },
    {
      path: 'sample-page',
      element: <SamplePage />
    },
    {
      path: 'orders',
      element: <Orders />
    },
    {
      path: '/orders/new',
      element: <OrdersCreate />
    },
    { path: '/orders/:id', element: <OrdersShow /> },       // <--- VER
    { path: '/orders/:id/edit', element: <OrdersEdit /> },         // <--- EDITAR
    { path: '/orders/:id/receive', element: <OrdersReceive /> },   // <--- RECIBIR
    { path: '/orders/:id/print', element: <OrdersPrint /> },       // <--- IMPRIMIR
    {
      path: '/orders/from-reservation/:id',
      element: <OrdersCreateFromReservation />
    },
    {
      path: 'users',
      element: <Users />
    },
    {
      path: 'revenue',
      element: <Revenue />
    }, {
      path: 'debts',
      element: <Debts />
    },
    {
      path: 'clients',
      element: <Clients />
    },
    {
      path: 'clothes',
      element: <Clothes />
    },
    { path: 'clothes/:id/edit', element: <ClothesEdit /> },
    {
      path: 'folk_dances',
      element: <FolkDances />
    },
    {
      path: 'warehouse',
      element: <Warehouse />
    },
    {
      path: 'register',
      element: <Register />
    },
    {
      path: 'roles',
      element: <Roles />
    },
    {
      path: 'access',
      element: <Access />
    },
    {
      path: 'calendar',
      element: <Calendar />
    },
    {
      path: 'clients/:dni',
      element: <ClientDetails />
    },
    {
      path: 'folk-dances/:id',
      element: <FolkDanceShow />
    },
    {
      path: 'folk-dances/:id/edit',
      element: <FolkDanceEdit />
    },
    {
      path: 'configuracion/cambiar-contrasena',
      element: <ChangePassword />
    },
    {
      path: '/reservations/new',
      element: <ReservationNew />
    },
    { path: '/orders/:id/print-a4', element: <OrdersPrintA4 /> },
    {
      path: 'reservations',
      element: <Reservations />
    },
    { path: '/reservations/:id/edit', element: <ReservationEdit /> },
    { path: '/reservations/:id', element: <ReservationShow /> },
    {
      path: 'order-edit-requests',
      element: <OrderEditRequestsPage />
    },
    {
      path: 'order-edit-requests-list',
      element: <OrderEditRequestsList />
    }
  ]
};

export default MainRoutes;
